import { TemplatePage } from './types';

const fathersDayPage: TemplatePage = {
  header: {
    color: '#F0E1DA',
    icon: 'images/video-templates/father-day.jpg',
    title: 'Father’s Day Video Templates Collection',
    title_meta: '30+ Father’s Day Video Templates - Easy-to-Edit and Free',
    description_meta:
      'Show off your creativity with Wave.video’s 30+ free and customizable Father’s day video templates.',
    description:
      'Show off your creativity with free and customizable Father’s day video templates. Make thumb-stopping ' +
      'marketing videos that any dad would be proud of.'
  },
  footer: {
    category: 'Father’s Day',
    description:
      'Wave.video’s collection of Father’s Day video templates is a lifesaver when it comes to making engaging ' +
      'marketing videos for your social media, blog, website, or email newsletter. Wave.video’s templates are free ' +
      'and easy to edit to reflect your brand.'
  },
  content: [
    {
      type: 'templates',
      title: 'Father’s Day Videos',
      search: {
        category: "/Holidays & Occasions/Father's Day"
      }
    },
    {
      type: 'stocks',
      title: 'father’s day',
      search: {
        category: 'fathers day'
      }
    },
    { type: 'calendar' }
  ]
};

export default fathersDayPage;
